document.addEventListener('click', async (event) => {
  // --- Close/dismiss button (added; existing quick-add logic below is unchanged) ---
  const closeButton = event.target.closest('[data-soie-cross-sell-close]');
  if (closeButton) {
    const section = closeButton.closest('.soie-cross-sell');
    if (section) {
      section.setAttribute('hidden', '');
      try {
        sessionStorage.setItem('soieCrossSellDismissed', '1');
      } catch (e) {
        /* ignore storage errors (e.g. private browsing) */
      }
    }
    return;
  }

  const button = event.target.closest('[data-soie-quick-add]');
  if (!button || button.disabled) return;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
    });
    if (!response.ok) throw new Error('Unable to add product');
    window.location.reload();
  } catch (error) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.querySelector('span:first-child').textContent = 'Try again';
  }
});

// --- Keep the section dismissed for this browsing session even after the cart
// drawer/page re-renders (e.g. after quantity changes), so closing it "sticks". ---
(() => {
  const STORAGE_KEY = 'soieCrossSellDismissed';

  const isDismissed = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  const hideDismissedSections = () => {
    if (!isDismissed()) return;
    document.querySelectorAll('.soie-cross-sell:not([hidden])').forEach((section) => {
      section.setAttribute('hidden', '');
    });
  };

  hideDismissedSections();

  if ('MutationObserver' in window) {
    new MutationObserver(hideDismissedSections).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
